import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import _ from 'lodash';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import i18n from 'i18next';
var gt = i18n.getFixedT(null, 'app');
/** 
 * A React Card Component
 * @constructor
 * @param {string} [id] - Container dom element #id
 * @param {string} [className] - Container dom element .class
 * @param {function} [onChange] - Callback function when value is chandged.
 * @param {array} [options] - It's selector's options.
 * 
 * 
 * options format: [{value: xxx, text:xxx}]
 * 
 * 
*/

var InputSelect = /*#__PURE__*/React.memo(function (props) {
  var id = props.id,
      onChange = props.onChange,
      className = props.className,
      options = props.options,
      defaultOptionText = props.defaultOptionText;
  var defaultOption = {
    value: 'all',
    text: defaultOptionText ? defaultOptionText : gt('global.lbl-all-logistic-name')
  };
  var optionList = [defaultOption].concat(_toConsumableArray(options));

  var _useState = useState(defaultOption),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      inputValue = _useState4[0],
      setInputValue = _useState4[1];

  var handleChangeValue = function handleChangeValue(newValue) {
    setValue(newValue);
    if (onChange) onChange(newValue);
  };

  var handleBlur = function handleBlur(event) {
    if (_.isEmpty(event.target.value)) {
      setValue(defaultOption);
      if (onChange) onChange('all');
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: className
  }, /*#__PURE__*/React.createElement(Autocomplete, {
    id: "controllable-states-demo",
    value: value,
    onChange: function onChange(event, newValue) {
      return handleChangeValue(newValue);
    },
    options: optionList,
    getOptionLabel: function getOptionLabel(option) {
      return option.text;
    },
    noOptionsText: gt('global.lbl-no-option'),
    onBlur: function onBlur(event) {
      return handleBlur(event);
    },
    renderInput: function renderInput(params) {
      return /*#__PURE__*/React.createElement(TextField, _extends({}, params, {
        title: params.inputProps.value,
        placeholder: "Placeholder"
      }));
    }
  }));
});
InputSelect.defaultProps = {
  id: 'c-inputSelect'
};
InputSelect.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.array
};
export default InputSelect;